import { render, staticRenderFns } from "./VantagensShowcase.vue?vue&type=template&id=a7d9c78a&scoped=true&"
import script from "./VantagensShowcase.vue?vue&type=script&lang=js&"
export * from "./VantagensShowcase.vue?vue&type=script&lang=js&"
import style0 from "./VantagensShowcase.vue?vue&type=style&index=0&id=a7d9c78a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d9c78a",
  null
  
)

export default component.exports